// extracted by mini-css-extract-plugin
export default {"qrWrapper":"LAKHmVdcUWl5YGjHchSQ"};